import React from 'react';
import './BottomSheet.css';

const BottomSheet = ({ open, onClose, children, className }) => {
  // Always render the sheet for correct animation and layout, but hide with CSS if not open
  return (
    <div
      className="bottom-sheet-backdrop"
      onClick={onClose}
      style={{ display: open ? 'flex' : 'none' }}
    >
      <div className={["bottom-sheet", className].filter(Boolean).join(" ")} onClick={e => e.stopPropagation()}>
        <button className="bottom-sheet-close" onClick={onClose}>&times;</button>
        {children}
      </div>
    </div>
  );
};

export default BottomSheet;
